module.exports = __webpack_public_path__ + "static/media/feature-7.c394ec7a.jpg";